// Translation: Register > Landing > Form > TOS dialog (German)
export default Object.freeze({})
